import { css } from 'styled-components'

export const sizes = {
  wide: 1560,
  desktop: 1280,
  tablet: 1024,
  phone: 700,
  small: 375,
};

export const colors = {
  white: '#fff',
  black: '#151515',
  gray: 'rgb(147, 147, 147)',
  danger: '#ccc',
  darkBlue: '#46639D',
  lightBlue: '#40bbca',
};

export const fonts = {
  RobotoCond: 'font-family: "Roboto Condensed", sans-serif;',
  Roboto: 'font-family: "Roboto", sans-serif;'  
}

export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label] / 16}em) {
      ${css(...args)};
    }
  `;

  return acc;
}, {});

export const Theme = {
  fonts,
  colors,
  media,
}

 
